import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { BarcodeDataService } from '../../../../../api/barcode-data.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  NewBarcodeGlobalCompanyPrefixMapping
} from '../../../../../shared/models/barcode-mapping.model';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {LoaderService} from '../../../../../core/loader/loader.service';
import {NotificationType} from '../../../../../shared/enum/notification.enum';
import {NotificationService} from '../../../../../service/notification.service';
import {User} from '../../../../../shared';

@Component({
  selector: 'app-global-company-prefix-edit-component',
  templateUrl: 'barcode-global-company-prefix-edit.component.html'
})

export class BarcodeGlobalCompanyPrefixEditComponent implements OnInit, OnDestroy {
  @Input() type = 'new';
  @Input() Id = undefined;
  @Input() data: NewBarcodeGlobalCompanyPrefixMapping = {};
  @Input() currentUser: User;
  @Input() isCloning = false;

  public globalCompanyPrefix = '';
  public businessEntityName = '';
  public website = '';
  public comment = '';

  private _destroyed$ = new Subject();

  constructor(
	private barcodeDataService: BarcodeDataService,
	public activeModal: NgbActiveModal,
	private loaderService: LoaderService,
	private notificationService: NotificationService,
  ) {
  }

  ngOnInit() {
	if (this.data) {
		this.globalCompanyPrefix = this.data.GlobalCompanyPrefix;
		this.businessEntityName = this.data.BusinessEntityName;
		this.website = this.data.Website;
		this.comment = this.data.Comment;
	}
  }

  saveGlobalCompanyPrefixData(e) {
	const result = e.validationGroup.validate();
	if (result.isValid) {
		this.loaderService.show();
		const data = {
		UserId: this.currentUser.UserId,
		BarcodeGlobalCompanyPrefixMappingId: this.data ? this.data.BarcodeGlobalCompanyPrefixMappingId : 0,
		GlobalCompanyPrefix: this.globalCompanyPrefix,
		BusinessEntityName: this.businessEntityName,
		Website: this.website,
		Comment: this.comment,
		IsCloning: this.isCloning
		};

		this.barcodeDataService.saveGlobalCompanyPrefixData(data)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
			this.notificationService.show('Global Company Prefix created', NotificationType.Success);
			this.loaderService.hide();
			this.activeModal.dismiss('saved');
		}, );
	}
  }

  ngOnDestroy() {
	this.loaderService.hide();
	this._destroyed$.next(null);
	this._destroyed$.complete();
  }
}
